import React from 'react';
import styles from "./JoinUs.module.css";
import joinUsLogo from "../Assets/joinUs.jpg";

export const JoinUs = () => {
    return (
        <div className={styles.container}>
            <img width="20%" src={joinUsLogo} alt="Join Us" />
            <p style={{ color: "#ececec" }} className={styles.info}>Join us to explore the possibilities of AI hardware innovation.
                
            </p>
        </div>
    );
};
